import React from "react";
import Routes from "../routes/Index";

export default props => <>{<Routes />}</>;